"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./BlockListItems.scss");
var _checkForExternalLink = _interopRequireDefault(require("../../utils/checkForExternalLink"));
var _EcommerceCard = _interopRequireDefault(require("../EcommerceCard/EcommerceCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Images Sizes here are the same when used in Carousel to preserve the 3:2 image ratio

const EcommerceCards = _ref => {
  let {
    content
  } = _ref;
  const GatsbyImage = content?.GatsbyImage;
  const nestedInTab = content?.tab;
  const {
    backgroundColor,
    color
  } = content?.theme || {};

  //if one or more cards has a productLabel, apply top margin to cards to correctly offset this label
  const productLabelPresent = content?.cards?.filter(card => {
    return card?.cardLabel;
  }).length > 0 ? true : false;
  const renderEcommerceCards = () => {
    if (content.cards && content.cards.length) {
      return content.cards.map((card, index) => {
        const {
          productPrice,
          cardLabel,
          productPageLink,
          trialLink
        } = card;
        const cardContent = {
          eyebrow: card?.eyebrow,
          header: card?.header,
          image: card?.image,
          cardLink: card?.cardLink,
          bgColor: !card?.image ? "grey" : "",
          text: card?.text,
          GatsbyImage: GatsbyImage,
          Link: content?.Link,
          cardLabel: cardLabel,
          productPrice: productPrice,
          productPageLink: productPageLink,
          trialLink: trialLink,
          hasTopMargin: productLabelPresent,
          pimContentfulId: card?.pimContentfulId
        };
        if (cardContent?.cardLink) {
          cardContent.cardLink.external = (0, _checkForExternalLink.default)(cardContent?.cardLink?.url);
        }
        return /*#__PURE__*/_react.default.createElement(_EcommerceCard.default, {
          key: index,
          content: cardContent,
          contentfulId: card?.contentfulId ? card?.contentfulId : null
        });
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-ecommerce-cards ter-ecommerce-cards--${content?.cards?.length}-cards`,
    style: {
      background: nestedInTab ? "#fff" : backgroundColor,
      color: color
    }
  }, renderEcommerceCards());
};
var _default = EcommerceCards;
exports.default = _default;